export default {
  crm: {
    title: 'CRM',
    dashboard: 'Dashboard',
    companies: 'Companies',
    prospects: 'Prospect Files',
    contacts: 'Contacts',
    interactions: 'Interactions',
    back_to_app: 'Back',

    // Navigation tabs
    tab_dashboard: 'Dashboard',
    tab_pipeline: 'Pipeline',
    tab_prospects: 'Prospects',
    new_prospect_btn: '+ New Prospect',

    // Dashboard stats
    stat_total_prospects: 'Total Prospects',
    stat_active_prospects: 'Active Prospects',
    stat_hot_prospects: 'Hot Prospects',
    stat_converted_month: 'Converted this month',
    pipeline_breakdown: 'Pipeline Breakdown',
    conversion_stats: 'Conversion Stats (30 days)',
    conversion_rate: 'Conversion rate',
    created_30d: 'Created',
    converted_30d: 'Converted',
    avg_delay: 'Average delay',
    days: 'days',
    recent_activity: 'Recent Activity',
    view_pipeline: 'View pipeline',

    // Pipeline
    pipeline_title: 'Pipeline',
    pipeline_total_value: 'Total Value',
    pipeline_avg_deal: 'Average Deal',
    temperature_hot: 'Hot',
    temperature_warm: 'Warm',
    temperature_cold: 'Cold',
    score: 'Score',
    prospect_moved: 'Prospect moved',
    no_prospects_in_column: 'No prospects',

    // Prospect detail
    company_info: 'Company Information',
    contact_info: 'Contact',
    score_card: 'Score',
    opportunities: 'Opportunities',
    metadata: 'Metadata',
    convert_to_exhibitor: 'Convert to Exhibitor',
    convert_confirm: 'Confirm converting this prospect to an exhibitor?',
    convert_success: 'Prospect converted to exhibitor successfully',
    convert_only_won: 'Only won prospects can be converted',
    already_converted: 'This prospect has already been converted',
    back_to_prospects: 'Back to Prospects',

    // Companies
    companies_management: 'Companies Management',
    company_name: 'Company Name',
    siret: 'SIRET',
    siren: 'SIREN',
    address: 'Address',
    city: 'City',
    postal_code: 'Postal Code',
    country: 'Country',
    phone: 'Phone',
    email: 'Email',
    website: 'Website',
    notes: 'Notes',
    new_company: 'New Company',
    edit_company: 'Edit Company',
    company_detail: 'Company Detail',
    siret_lookup: 'SIRET Lookup',
    siret_lookup_placeholder: 'Enter SIRET number...',
    siret_lookup_btn: 'Search',
    siret_not_found: 'No company found for this SIRET',
    delete_company_confirm: 'Are you sure you want to delete this company?',
    company_created: 'Company created successfully',
    company_updated: 'Company updated successfully',
    company_deleted: 'Company deleted successfully',

    // Contacts
    first_name: 'First Name',
    last_name: 'Last Name',
    position: 'Position',
    is_primary: 'Primary Contact',
    new_contact: 'New Contact',
    edit_contact: 'Edit Contact',
    delete_contact_confirm: 'Are you sure you want to delete this contact?',
    contact_created: 'Contact created successfully',
    contact_updated: 'Contact updated successfully',
    contact_deleted: 'Contact deleted successfully',
    no_contacts: 'No contacts yet',

    // Prospect Files
    prospect_files: 'Prospect Files',
    new_prospect: 'New Prospect File',
    edit_prospect: 'Edit Prospect File',
    prospect_detail: 'Prospect Detail',
    status: 'Status',
    priority: 'Priority',
    source: 'Source',
    estimated_surface: 'Estimated Surface (m\u00B2)',
    estimated_budget: 'Estimated Budget',
    select_event: 'Select an event',
    select_company: 'Select a company',
    select_contact: 'Select a contact',
    delete_prospect_confirm:
      'Are you sure you want to delete this prospect file?',
    prospect_created: 'Prospect file created successfully',
    prospect_updated: 'Prospect file updated successfully',
    prospect_deleted: 'Prospect file deleted successfully',
    no_prospects: 'No prospect files yet',

    // Statuses
    status_new: 'New',
    status_contacted: 'Contacted',
    status_qualified: 'Qualified',
    status_proposal: 'Proposal',
    status_negotiation: 'Negotiation',
    status_won: 'Won',
    status_lost: 'Lost',

    // Priorities
    priority_low: 'Low',
    priority_medium: 'Medium',
    priority_high: 'High',

    // Interactions
    interaction_type: 'Type',
    subject: 'Subject',
    content: 'Content',
    interaction_date: 'Date',
    new_interaction: 'New Interaction',
    delete_interaction_confirm:
      'Are you sure you want to delete this interaction?',
    interaction_created: 'Interaction created successfully',
    interaction_deleted: 'Interaction deleted successfully',
    no_interactions: 'No interactions yet',

    // Interaction types
    type_call: 'Call',
    type_email: 'Email',
    type_meeting: 'Meeting',
    type_note: 'Note',
    type_other: 'Other',

    // Common
    search_placeholder: 'Search...',
    no_results: 'No results found',
    back: 'Back',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    confirm: 'Confirm',
    actions: 'Actions',
    created_at: 'Created',
    updated_at: 'Updated',
  },
};
